import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { faEnvelopeOpen, faLock, faMapMarker, faPhone, faUpload, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useForm } from 'react-hook-form';
import useProfile from '../../../Hooks/useProfile';

const ProfileRight = () => {
    const { register, handleSubmit, formState, reset, formState: { errors } } = useForm();
    const { isSubmitting } = formState
    const screet_key = 'e7b3c92c06537e14d85d152ffd62709c';
    const [user] = useProfile();
    const userSingleId = user?._id;


    const onSubmit = data => {
        const image = data?.profile[0];
        const formData = new FormData()
        formData.append('image', image);



        // post Api Calling methods
        const url = `https://api.imgbb.com/1/upload?key=${screet_key}`;

        fetch(url, {
            method: 'POST',
            body: formData
        })
            .then(res => res.json())
            .then(result => {
                if (result?.success) {
                    const photo = result?.data?.url;

                    const updateData = {
                        name: data?.name,
                        email: data?.email,
                        phone: data?.phone,
                        presentAddress: data?.presentAddress,
                        profile: photo
                    }

                    //post data in mongodb 

                    fetch(`https://one0m-backend2.onrender.com/auth/profile/${userSingleId}`, {
                        method: 'PUT',
                        headers: {
                            'content-type': 'application/json',
                            authorization: `Bearer ${localStorage.getItem('token')}`
                        },
                        body: JSON.stringify(updateData)
                    })
                        .then(res => res.json())
                        .then(result2 => {
                            if (result2?.success) {
                                toast.success(result2?.message);
                                reset();
                            }
                        })
                }
            })

        return new Promise((resolve) => {
            setTimeout(() => {
                resolve()
            }, 9000)
        })

    }


    return (
        <div className='shadow-lg p-3 rounded'>
            <h6 className='mb-3 text-primary fw-bold'>Update Profile</h6>
            <form onSubmit={handleSubmit(onSubmit)}>

                <div className="row gy-2">
                    <div className="col-lg-12">
                        <div class="input-group mb-2">
                            <span className="input-group-text" id="basic-addon1"><FontAwesomeIcon icon={faUser} /></span>
                            <input {...register("name")} className='form-control' placeholder='Your Full Name' type='text' />
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div class="input-group mb-2">
                            <span className="input-group-text" id="basic-addon1"><FontAwesomeIcon icon={faEnvelopeOpen} /></span>
                            <input {...register("email")} className='form-control' placeholder='Email address' type='email' />
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div class="input-group mb-2">
                            <span className="input-group-text" id="basic-addon1"><FontAwesomeIcon icon={faPhone} /></span>
                            <input {...register("phone")} className='form-control' placeholder='Phone OR mobile number' type='number' />
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div class="input-group mb-2">
                            <span className="input-group-text" id="basic-addon1"><FontAwesomeIcon icon={faMapMarker} /></span>
                            <textarea {...register("presentAddress")} className='form-control' placeholder='Your present address' type='text' />
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div class="input-group mb-2">
                            <span className="input-group-text" id="basic-addon1"><FontAwesomeIcon icon={faUpload} /></span>
                            <input {...register("profile")} className='form-control' type='file' />
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <button className="d-block btn btn-danger w-100 border-0 text-light fw-bold rounded p-2">
                            Save Change
                            {isSubmitting && (
                                <div class="spinner-border spinner-border-sm ms-2" role="status">
                                    <span class="visually-hidden ">Loading...</span>
                                </div>
                            )}

                        </button>
                    </div>
                </div>
            </form>
            <ToastContainer />
        </div>
    );
};

export default ProfileRight;